import PropTypes from 'prop-types';
import { BillToParty } from '../enums/bill-to-party';

export const BillToPartyPropType = PropTypes.oneOf(BillToParty);

/**
 * @typedef {(
 *   'Account'|
 *   'Recipient'|
 *   'ThirdParty'|
 *   'Collect'|
 *   'OtherAccount'
 * )} BillToPartyPropType
 */
